import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import PipelineHealth from "@/pages/PipelineHealth";
import EntityReview from "@/pages/EntityReview";
import NRReview from "@/pages/NRReview";
import TrajectoryBoard from "@/pages/TrajectoryBoard";
import GroupingReview from "@/pages/GroupingReview";
import SnapshotHealth from "@/pages/SnapshotHealth";
import ScoringConfig from "@/pages/ScoringConfig";
import ExperimentalSources from "@/pages/ExperimentalSources";
import CrossSourceGraph from "@/pages/CrossSourceGraph";
import CapitalReview from "@/pages/CapitalReview";
import ConceptBrief from "@/pages/ConceptBrief";
import SystemHealth from "@/pages/SystemHealth";
import ResearchQueue from "@/pages/ResearchQueue";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#09090B] text-[#71717A] font-mono text-sm flex items-center justify-center">Authenticating…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" theme="dark" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/products" element={<Protected><Products /></Protected>} />
          <Route path="/products/:id" element={<Protected><ProductDetail /></Protected>} />
          <Route path="/pipeline" element={<Protected><PipelineHealth /></Protected>} />
          <Route path="/entity" element={<Protected><EntityReview /></Protected>} />
          <Route path="/nr-review" element={<Protected><NRReview /></Protected>} />
          <Route path="/trajectory" element={<Protected><TrajectoryBoard /></Protected>} />
          <Route path="/graph" element={<Protected><CrossSourceGraph /></Protected>} />
          <Route path="/capital-review" element={<Protected><CapitalReview /></Protected>} />
          <Route path="/opportunity-brief" element={<Protected><ConceptBrief /></Protected>} />
          <Route path="/system-health" element={<Protected><SystemHealth /></Protected>} />
          <Route path="/research" element={<Protected><ResearchQueue /></Protected>} />
          <Route path="/grouping" element={<Protected><GroupingReview /></Protected>} />
          <Route path="/snapshots" element={<Protected><SnapshotHealth /></Protected>} />
          <Route path="/scoring" element={<Protected><ScoringConfig /></Protected>} />
          <Route path="/experimental" element={<Protected><ExperimentalSources /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
